<script>import { createEventDispatcher } from "svelte";
export let imageSrc;
export let imageWidth = null;
export let imageHeight = null;
export let pictureSizes;
export let pictureSources;
export let imgClasses = "";
export let imgElement = void 0;
export let alt;
export let loading = "eager";
export let attributes = {};
const dispatch = createEventDispatcher();
let loadFallback = false;
function onError(e) {
  if (imgElement && imgElement.src !== imgElement.currentSrc) {
    loadFallback = true;
  }
  dispatch("error", e);
}
function onLoad(e) {
  dispatch("load", e);
}
</script>

<picture>
  {#if !loadFallback && pictureSources}
    {#each pictureSources as [type, srcset]}
      <source type="image/{type}" {srcset} sizes="{pictureSizes}" />
    {/each}
  {/if}
  <img
    src="{imageSrc}"
    {alt}
    {loading}
    {...attributes}
    width="{imageWidth}"
    height="{imageHeight}"
    class="{imgClasses}"
    bind:this="{imgElement}"
    on:error="{onError}"
    on:load="{onLoad}"
  />
</picture>
